var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hot-pilar-card _text-center"},[_c('hot-image',_vm._b({},'hot-image',_vm.image,false)),_vm._v(" "),_c('p',{staticClass:"hot-pilar-card__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"hot-pilar-card__body"},[_vm._v(_vm._s(_vm.body))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }